import React, { useState, useEffect, useContext } from "react";
import { Grid, Card, CardContent, Typography, Box, Button, CardMedia, FormGroup, Checkbox, FormControlLabel, CircularProgress } from "@mui/material";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import "./ExitManagement.css";
import config from "config/config";
import Context from "context/context";
import { toast } from "react-toastify";
import ReusableTable from "components/table/table";
import Tooltip from '@mui/material/Tooltip';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import selfassessment from 'assets/images/selfassesment.png'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ToastContainer } from 'react-toastify';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as moment from "moment";
import exitManagementAPI from "apis/panel/ExitManagement/exitManagement";
import swal from 'sweetalert';



import {

  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,

} from "@mui/material";
import { Height } from "../../../../node_modules/@mui/icons-material/index";

const EMS_IT = () => {

  const [resignations, setResignations] = useState([]);



  
  const [selectedCycle, setSelectedCycle] = useState(null);
  const [templateData, setTemplateData] = useState([]);

  const limit = 10;
  const [offset, setOffset] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  
  const { state, dispatch } = useContext(Context);
  const [count, setCount] = useState(0); // Add a count for pagination

  const [value, setValue] = useState("1");
  const [HRlist, setHRlist] = useState(true);
  const [resignationDetails, setResignationDetails] = useState("");
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [clearanceItems, setClearanceItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remarks, setRemarks] = useState("");

  const {getAllClearanceResignationsAPI,getEmployeeClearanceItemsAPI,updateResignationAPI} = exitManagementAPI()

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };


  const handleCloseModal = () => {
    setIsModalOpen(false);
  };


  // const handleItemChange = (item) => {
  //   setSelectedItems((prevSelected) =>
  //     prevSelected.includes(item) ? prevSelected.filter((i) => i !== item) : [...prevSelected, item]
  //   );
  // };

  // const confirmSelection = () => {
  //   setIsModalOpen(false);
  // };



  useEffect(() => {
    fetchAllResignations();
  }, [offset]);

  
  const fetchAllResignations = async () => {
    try {
      const query = {
          offset: (offset - 1) * limit,
          limit: limit,

        }
      
      dispatch({ type: "SET_LOADING", payload: true });
     
      const data = await getAllClearanceResignationsAPI(query);

      if (data.status === "Ok" && Array.isArray(data.allResignations)) {
        setResignations(data.allResignations);
        setCount(data.count);
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching resignations:", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const tableDataModal = resignations.map((resignation, index) => [
    index + 1 + (offset - 1) * limit,
    resignation.employeeCode, // Employee Code
    resignation.firstName, // Name
    resignation.role, // Role
    resignation.dept, // Department
    resignation.requestStatus, // Request Status
     resignation?.attritionType,
    resignation.approvalStatus, // Approval Status
    new Date(resignation.appliedOn).toISOString().split("T")[0],
    <Tooltip title="View Details" key={resignation.exitId}>
      <span className="jobType">
        <RemoveRedEyeIcon
          style={{
            color: (resignation.approvalStatus === "Final Approved" || resignation.approvalStatus === "Clearance Completed")
              ? "grey"  // Grey color when both conditions are met
              : "#E97000",  // Orange color for other statuses
            cursor: (resignation.approvalStatus === "Final Approved" || resignation.approvalStatus === "Clearance Completed")
              ? "not-allowed"  // Not allowed cursor when both conditions are met
              : "pointer",  // Pointer cursor for clickable interaction
          }}
          onClick={() => {
            if (resignation.approvalStatus === "Final Approved" || resignation.approvalStatus === "Clearance Completed") {
              toast.info("This resignation is finalized and clearance is completed; it cannot be edited.");
            } else {
              fetchClearanceItems(resignation.exitId); // Function to handle view action
            }
          }}
        />
      </span>
    </Tooltip>,
  ]);




  const fetchClearanceItems = async (exitId) => {
    dispatch({ type: "SET_LOADING", payload: true });

    try {
     

      const data = await getEmployeeClearanceItemsAPI(exitId);
      if (data.status === "Ok" && Array.isArray(data.result) && data.result.length > 0) {
        const employeeData = data.result[0];


        setClearanceItems(employeeData.items);
        setHRlist(false);

        // Store all data in state
        setResignationDetails({
          employeeId: employeeData.employeeId,
          employeeCode: employeeData.employeeCode,
          firstName: employeeData.firstName,
          exitReason: employeeData.exitReason,
          lwd: employeeData.lwd,
          exitId: employeeData.exitId,
          items: employeeData.items, // Already setting this separately for `setClearanceItems`
        });

       
      } else {
        setClearanceItems([]);
      }
    } catch (error) {
      console.error("Error fetching clearance items:", error);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });

    }
  };


  const handleClearanceSubmit = async () => {
    if (!resignationDetails.exitId || selectedItems.length === 0) {
      toast.error("Exit ID or clearance items are missing.");
      return;
    }
     const confirmation = await swal({
                    title: "Confirm",
                    text: " Are you sure you want to proceed with the Approve / Rejection?",
                    icon: "warning",
                    buttons: {
                      cancel: {
                        text: "Reject",
                        value: false,
                        visible: true,
                        className: "swal-button-disagree",
                      },
                      confirm: {
                        text: "Accept",
                        value: true,
                        visible: true,
                        className: "swal-button-agree",
                      },
                    },
                    dangerMode: false,
                  });
                   if(confirmation){

    try {
      dispatch({ type: "SET_LOADING", payload: true });

      

       const body = {
            exitId: resignationDetails.exitId,
            itemIds: selectedItems.map((item) => item.itemId),// Ensure selectedItems contains valid UUIDs
            remarks: remarks,
          }
      const data = await updateResignationAPI(body);

      if (data.status === "Ok") {
        toast.success("Clearance updated successfully!");
        setHRlist(true);
        fetchAllResignations();
        setSelectedItems([])
          setRemarks('')

      } else {
        toast.error("No changes were made. Try again.");
      }
    } catch (error) {
      console.error("Error submitting clearance:", error);
      toast.error(`Error: ${error.message}`);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }
  };


  const handleItemSelection = (item) => {
    setSelectedItems((prev) => {
      const exists = prev.some((selected) => selected.itemId === item.itemId);
      return exists
        ? prev.filter((selected) => selected.itemId !== item.itemId)
        : [...prev, { itemId: item.itemId, itemName: item.itemName }];
    });
  };


  return (


    <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <Box sx={{ width: '100%', typography: 'body1' }}>


        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '100%', overflowX: 'auto', marginTop: "2%", marginBottom: "2%" }}>
            <Typography
              variant="h5"
              align="center"
              className="self-title"

            >
              Pending Clearance
            </Typography>
            {HRlist ? (

              <ReusableTable

                data={tableDataModal}
                count={count}
                offset={offset}
                setOffset={setOffset}
                limit={limit}
                setSearchValue={setSearchValue}
                heading={[
                  "S.No",
                  "Employee Code",
                  "Name",
                  "Role",
                  "Department",
                  "Request Status",
                  "Attrition Type",
                  "Approval Status",
                  "Applied On",
                  "Action",
                ]} // Table headers
              />
            ) : (
              <>
                <Grid container spacing={2} sx={{ pl: 6, pr: 5, pb: 5, mt: 2 }}>
                  {/* KRA */}
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Employee ID</Box>
                    <TextField
                      sx={{ border: "1px solid #B2D4F8" }}
                      id="kraCategory"
                      name="kraCategory"
                      placeholder=""
                      variant="outlined"
                      fullWidth
                      disabled
                      value={resignationDetails.employeeCode}
                      InputProps={{ readOnly: true }} // Make it readonly
                    />
                  </Grid>

                  {/* KPI */}
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Employee Name </Box>
                    <TextField
                      sx={{ border: "1px solid #B2D4F8" }}
                      id="kpiName"
                      name="kpiName"
                      placeholder=""
                      variant="outlined"
                      fullWidth
                      disabled
                      value={resignationDetails.firstName}
                      InputProps={{ readOnly: true }} // Make it readonly
                    />
                  </Grid>

               
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Last Working Date</Box>
                    <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                      <DatePicker
                        sx={{ width: "100%" }}
                        id="dateOfBirth"
                        name="dateOfBirth"
                        value={resignationDetails.lwd ? moment(resignationDetails.lwd).toDate() : null} readOnly // Make the field read-only
                        disabled // Disable user interaction
                        slotProps={{
                          field: { clearable: true },
                        }}
                        format="dd/MM/yyyy"
                        renderInput={(params) => <TextField {...params} helperText={null} />}
                      />
                    </LocalizationProvider>

                  </Grid>

                  {/* Input Box with Button */}
                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Selected Items</Box>
                    <TextField
                      fullWidth
                      variant="outlined"
                      value={selectedItems.map((item) => item.itemName).join(", ")}
                      placeholder="Select items"
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <Button variant="contained" onClick={handleOpenModal} sx={{ ml: 2 }}>
                            Select
                          </Button>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                    <Box className="label">Remarks</Box>
                    <TextField
                      fullWidth
                      variant="outlined"
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)} // Store the remarks
                      placeholder="Enter remarks"
                    />
                  </Grid>



                  {/* Justification */}

                </Grid>
                <Grid container spacing={1} sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }} >
                  <Grid item xs={12} sm={2} md={2} lg={2}>
                    <Button className="cancelButton" onClick={() => {
                      setHRlist(true);
                      setSelectedItems([]);
                        setRemarks('')

                    }}>Cancel</Button>
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} lg={2}>
                    <Button className="saveButton" onClick={handleClearanceSubmit}> Submit </Button>
                  </Grid>
                </Grid>
              </>
            )}
            <Dialog
              open={isModalOpen}
              onClose={handleCloseModal}
              PaperProps={{
                sx: {
                  width: "400px", // Adjust width as needed
                  borderRadius: "12px",
                  padding: "16px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              <DialogTitle sx={{ fontSize: "18px", fontWeight: "bold", textAlign: "center", color: "#333" }}>
                Clearance Items
              </DialogTitle>
              <DialogContent dividers sx={{ maxHeight: "300px", overflowY: "auto", padding: "10px 20px" }}>
                {loading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                    <CircularProgress size={30} />
                  </Box>
                ) : clearanceItems.length > 0 ? (
                  <FormGroup sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    {clearanceItems.map((item) => (
                      <FormControlLabel
                        key={item.itemId}
                        control={
                          <Checkbox
                            checked={selectedItems.some((selected) => selected.itemId === item.itemId)}
                            onChange={() => handleItemSelection(item)}
                            sx={{
                              color: "#1976d2",
                              "&.Mui-checked": { color: "#1976d2" },
                            }}
                          />
                        }
                        label={
                          <Typography sx={{ fontSize: "14px", color: "#555" }}>{item.itemName}</Typography>
                        }
                      />
                    ))}
                  </FormGroup>
                ) : (
                  <Typography sx={{ textAlign: "center", fontSize: "14px", color: "#888" }}>
                    No clearance items found.
                  </Typography>
                )}
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center", padding: "12px" }}>
                <Button
                  onClick={handleCloseModal}
                  variant="contained"
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    textTransform: "none",
                    "&:hover": { backgroundColor: "#1565c0" },
                  }}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

          </div>  </div>
      </Box>
    </div>
  );
};

export default EMS_IT;

